import { type IThemePalette } from "../types";

export interface IInputTokens {
  height: number;
  minHeightMultiline: number;
  paddingHorizontal: number;
  fontSize: number;
  borderRadius: number;
  editableBg: string;
  readOnlyBg: string;
  editableBorder: string;
  readOnlyBorder: string;
  focusBorder: string;
  hoverBorder: string;
  errorBorder: string;
  textColor: string;
  readOnlyTextColor: string;
  placeholderColor: string;
  errorTextColor: string;
}

export interface ISegmentedControlTokens {
  trackBg: string;
  trackBorder: string;
  selectedBg: string;
  selectedText: string;
  restingText: string;
  mutedText: string;
  hoverBorder: string;
  dangerColor: string;
  borderRadius: number;
}

export interface IPanelChromeTokens {
  backgroundColor: string;
  borderColor: string;
  headerBorderColor: string;
  borderRadius: number;
  padding: number;
}

export interface IInputFormTheme {
  input: IInputTokens;
  segmented: ISegmentedControlTokens;
  panel: IPanelChromeTokens;
}

/**
 * Pure factory generating the input, segmented control, and form chrome component theme.
 *
 * @param palette - The active semantic theme palette.
 * @param isDark - Whether dark mode is currently active.
 * @returns Fully resolved IInputFormTheme.
 */
export function getInputFormTheme(palette: IThemePalette, isDark: boolean): IInputFormTheme {
  return {
    input: {
      height: 36,
      minHeightMultiline: 64,
      paddingHorizontal: 10,
      fontSize: 13,
      borderRadius: 0,
      editableBg: palette.inputEditable,
      readOnlyBg: palette.inputReadOnly,
      editableBorder: palette.inputEditableBorder,
      readOnlyBorder: palette.inputReadOnlyBorder,
      focusBorder: palette.tint,
      hoverBorder: palette.buttonHoverBorder,
      errorBorder: palette.danger,
      textColor: palette.inputText,
      readOnlyTextColor: palette.inputReadOnlyText,
      placeholderColor: palette.textMuted,
      errorTextColor: palette.danger,
    },
    segmented: {
      trackBg: isDark ? "rgba(255, 255, 255, 0.06)" : "rgba(150, 150, 150, 0.1)",
      trackBorder: isDark ? "rgba(255, 255, 255, 0.12)" : "rgba(150, 150, 150, 0.15)",
      selectedBg: palette.tint,
      selectedText: "#1C1917",
      restingText: palette.text,
      mutedText: palette.textMuted,
      hoverBorder: palette.buttonHoverBorder,
      dangerColor: palette.danger,
      borderRadius: 0,
    },
    panel: {
      backgroundColor: palette.card,
      borderColor: palette.border,
      headerBorderColor: palette.border,
      borderRadius: 4,
      padding: 10,
    },
  };
}
